export default __webpack_public_path__ + "static/media/layer2.6df53ad5.png";